import LoginImage from './assets/eeri_logo_square_2019_2.5x2.5.png';
import bannerImage from './assets/EERI_Banner_3d.png';
import dummyVideos from './data/dummyVideos';
import MatchboxIcon from './assets/favicon.ico';
import MatchboxLogo from './assets/matchbox-logo-white-small.png';

const SiteData = {
  loginTitle:
    "EERI 2021 Webinar Series - February",
  loginImagesrc: LoginImage,
  loginImagealt: 'AHLA Logo',
  attendeeTitle:
    'EERI 2021 Webinar Series - February',
  matchboxLogo: MatchboxIcon,
  matchboxIcon: MatchboxLogo,
  endOfEventPageTitle:
    'EERI 2021 Webinar Series - February',
  matchboxLogoAlt: 'matchbox logo',
  matchboxLogoTitle: 'hello',
  attendantTitle: 'EERI 2021 Webinar Series - February',
  titleIndex: 'EERI 2021 Webinar Series',
  auditorium: false,
  preRegister: true,
  checkRegisterList: false,
  generalChatId: 1,
  auditoriumChatIds: [2],
  schemaName: 'eerifebwebinar',
  Isbanner: true,
  isMultipleAuditorium: false,
  bannerData: {
    backgroundURL: bannerImage,
    // videoURL:
    //    'https://expohallimages.s3-us-west-2.amazonaws.com/media/ahlaphi/ahla009-preroll-and-tutorial.mp4',
  },
};
export default SiteData;
